import type { RouteLocationRaw } from 'vue-router'

import { useGetStartedAccess } from '../composables/useGetStartedAccess'

/**
 * Where a just-booted session that landed on Summary should go instead (legacy
 * `DefaultLayout.vue:208-209`: after every `bootUser`, Summary → Get Started while the account is
 * eligible). `null` keeps the user on Summary. The composition root decides *when* to ask.
 */
export async function resolveGetStartedLanding(): Promise<RouteLocationRaw | null> {
  const access = useGetStartedAccess()
  await access.ensureLoaded()
  return access.available.value ? { name: 'GetStarted' } : null
}
